/* ArdanShield v7: scoped remediation for product rails, initial PDP media and optional accordions. */
(() => {
  'use strict';

  const getFlickity = element => window.Flickity && window.Flickity.data(element);

  function resizeProductRails(scope = document) {
    scope.querySelectorAll('.products-slider.flickity-enabled').forEach(slider => {
      const instance = getFlickity(slider);
      if (instance) instance.resize();
    });
  }

  function prepareProductRails(scope = document) {
    scope.querySelectorAll('.products-slider').forEach(slider => {
      slider.querySelectorAll('.flickity-prev-next-button').forEach(button => {
        const direction = button.classList.contains('previous') ? 'Previous' : 'Next';
        button.setAttribute('aria-label', `${direction} products`);
      });
      slider.querySelectorAll('img').forEach(image => {
        if (!image.complete) image.addEventListener('load', () => resizeProductRails(scope), { once: true });
      });
    });
    resizeProductRails(scope);
  }

  function prepareGallery(wrapper) {
    const gallery = wrapper.querySelector('[data-product-gallery]');
    if (!gallery) return;

    let userChangedVariant = false;
    const product = wrapper.closest('.product_section') || document;
    product.addEventListener('change', event => {
      if (event.isTrusted && event.target.matches('select, input[type="radio"]')) userChangedVariant = true;
    }, true);

    const selectInitialFeaturedMedia = () => {
      if (userChangedVariant || gallery.dataset.asInitialMediaSet === 'true') return;
      if (new URLSearchParams(window.location.search).has('variant')) {
        gallery.dataset.asInitialMediaSet = 'true';
        return;
      }
      const instance = getFlickity(gallery);
      const featuredId = gallery.dataset.initialFeaturedMediaId;
      if (!instance || !featuredId) return;
      const featuredCell = gallery.querySelector(`[data-media-id="${featuredId}"]`);
      if (!featuredCell) return;
      const index = instance.getCellElements().indexOf(featuredCell);
      if (index >= 0) {
        instance.select(index, false, true);
        gallery.dataset.asInitialMediaSet = 'true';
      }
    };

    const updateCounter = () => {
      const instance = getFlickity(gallery);
      const current = wrapper.querySelector('[data-product-gallery-current]');
      if (instance && current) current.textContent = String(instance.selectedIndex + 1);
    };

    gallery.querySelectorAll('.flickity-prev-next-button').forEach(button => {
      const direction = button.classList.contains('previous') ? 'Previous' : 'Next';
      button.setAttribute('aria-label', `${direction} product media`);
    });

    if (window.jQuery) window.jQuery(gallery).on('change.flickity.asV7', updateCounter);
    window.requestAnimationFrame(() => {
      selectInitialFeaturedMedia();
      updateCounter();
    });
    window.addEventListener('load', () => {
      prepareProductRails();
      selectInitialFeaturedMedia();
      updateCounter();
    }, { once: true });
  }

  function prepareAccordions(scope = document) {
    scope.querySelectorAll('[data-product-information-accordion]').forEach(details => {
      const summary = details.querySelector('summary');
      if (!summary) return;
      const isTarget = window.location.hash === `#${details.id}`;
      details.open = isTarget;
      summary.setAttribute('aria-expanded', String(isTarget));
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
    });
  }

  function initialise(scope = document) {
    prepareProductRails(scope);
    scope.querySelectorAll('[data-product-gallery-wrapper]').forEach(prepareGallery);
    prepareAccordions(scope);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initialise();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => resizeProductRails());
  });
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => resizeProductRails(), 120);
  });
})();
